import React, { Component } from 'react';
import { Portal } from 'react-portal';
import PropTypes from 'prop-types';

import {
  SR_API_ACTION_HOUSEHOLD_MERGE_HOUSEHOLDS,
} from 'api/actionTypes';
import {
  DATA_TABLE_SOURCE_HOUSEHOLD_DASHBOARD,
} from 'common/dataTableConstants';

import {
  actionDataTableReset,
} from 'client/helpers/dataTables';
import extractPhoneFromText from 'common/util/extractPhoneFromText';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';
import branch from 'client/core/branch';

@withApiState({
  mergeHouseholdsApiState: {
    action: SR_API_ACTION_HOUSEHOLD_MERGE_HOUSEHOLDS,
  },
})
@branch({})
class SrAdminMergeHouseholdsModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    mergeHouseholdsApiState: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.initialState = {
      userPhone1: '',
      userPhone2: '',
    };
    this.state = this.initialState;
  }

  _onUserPhone1Change = (event) => {
    const newUserPhone = event.target.value.trim();
    if (
      (newUserPhone[0] === '+' && newUserPhone.length > 12) ||
      (newUserPhone[0] !== '+' && newUserPhone.length > 10)
    ) {
      return;
    }

    this.setState({
      userPhone1: event.target.value,
    });
  }

  _onUserPhone2Change = (event) => {
    const newUserPhone = event.target.value.trim();
    if (
      (newUserPhone[0] === '+' && newUserPhone.length > 12) ||
      (newUserPhone[0] !== '+' && newUserPhone.length > 10)
    ) {
      return;
    }

    this.setState({
      userPhone2: event.target.value,
    });
  }

  _onSubmit = () => {
    const { dispatch, onClose } = this.props;
    const { userPhone1, userPhone2 } = this.state;

    dispatch(postWithState, {
      action: SR_API_ACTION_HOUSEHOLD_MERGE_HOUSEHOLDS,
      payload: {
        userPhone1,
        userPhone2,
      },
    }).then(() => {
      this.setState(this.initialState);
      dispatch(actionDataTableReset, {
        dataSource: DATA_TABLE_SOURCE_HOUSEHOLD_DASHBOARD,
      });
      onClose();
    });
  }

  render() {
    const {
      userPhone1,
      userPhone2,
    } = this.state;

    const {
      mergeHouseholdsApiState,
      onClose,
      isOpen,
    } = this.props;

    const isDisabled = (
      (!extractPhoneFromText(userPhone1) || !extractPhoneFromText(userPhone2)) ||
      mergeHouseholdsApiState.inProgress
    );

    if (!isOpen) {
      return null;
    }

    return (
      <Portal>
        <div className='optionSelectionModal'>
          <div className='backdrop' onClick={onClose}>
            <div className='form' onClick={(evt) => evt.stopPropagation()}>
              <h1>merge households</h1>
              <input
                onChange={this._onUserPhone1Change}
                value={userPhone1}
                placeholder='User Phone 1'
              />
              <input
                onChange={this._onUserPhone2Change}
                value={userPhone2}
                placeholder='User Phone 2'
              />
              <ButtonDeprecated onClick={this._onSubmit} disabled={isDisabled}>
                <span>{mergeHouseholdsApiState.inProgress ? 'merging...' : 'merge'}</span>
              </ButtonDeprecated>
              {mergeHouseholdsApiState.error && (
                <div className='errorMessage'>
                  {mergeHouseholdsApiState.error.message}
                </div>
              )}
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrAdminMergeHouseholdsModal.displayName = 'SrAdminMergeHouseholdsModal';

export default SrAdminMergeHouseholdsModal;
